var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 17.0449H13.125V14.7949H10.875V17.0449ZM10.875 12.5449H13.125V5.79492H10.875V12.5449ZM12 22.6699C5.79 22.6699 0.75 17.6299 0.75 11.4199C0.75 5.20992 5.79 0.169922 12 0.169922C18.21 0.169922 23.25 5.20992 23.25 11.4199C23.25 17.6299 18.21 22.6699 12 22.6699ZM12 2.41992C7.03875 2.41992 3 6.45867 3 11.4199C3 16.3812 7.03875 20.4199 12 20.4199C16.9613 20.4199 21 16.3812 21 11.4199C21 6.45867 16.9613 2.41992 12 2.41992Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.672f4871d5233983fe1784528c871dd9.svg";
export { ForwardRef as ReactComponent };